export default defineNuxtPlugin(() => {
  function loadScript() {
    window.removeEventListener('touchstart', loadScript);
    window.removeEventListener('mousemove', loadScript);
    window.removeEventListener('scroll', loadScript);

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 3420176, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      r.defer = true;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }

  window.addEventListener('touchstart', loadScript);
  window.addEventListener('mousemove', loadScript);
  window.addEventListener('scroll', loadScript);
});
